import { lazy } from 'react'
import serverData from '../utils/server-data'
import DeletionFeedback from '../modals/dataPrivacy/data-deletion/feedback'
import Deletionemail from '../modals/dataPrivacy/data-deletion/email'
import DataDeletion from '../modals/dataPrivacy/data-deletion/introduction'
import DeletionSuccess from '../modals/dataPrivacy/data-deletion/success'
const { closeUrl = null, backUrl = null, showBackButton = true } = serverData
export default {
  '/data/dar': {
    view: lazy(() => import('../modals/dataPrivacy/data-access/request-form')),
    props: {
      closeUrl,
      domid: 'request_form_modal',
    },
  },

  '/data/correctionpage': {
    view: lazy(() => import('../modals/dataPrivacy/data-correction/index')),
    props: {
      closeUrl,
      domid: 'correction_page',
    },
  },

  '/data/correction': {
    //merchant correction page
    view: lazy(() =>
      import('../modals/dataPrivacy/data-correction/merchant-correction'),
    ),
    props: {
      closeUrl,
      domid: 'merchant_correction',
    },
  },

  '/data/dar/yourrequests': {
    view: lazy(() =>
      import('../modals/dataPrivacy/data-access/request-history'),
    ),
    props: {
      closeUrl,
      domid: 'your_requests_modal',
    },
  },

  '/data/dar/2fareturn': {
    view: lazy(() => import('../modals/dataPrivacy/data-access/request-form')),
    props: {
      closeUrl,
      redirect: 'authweb',
      domid: 'authweb_request_form_modal',
    },
  },

  '/data/deletion': {
    view: lazy(() =>
      import('../modals/dataPrivacy/data-deletion/introduction'),
    ),
    props: {
      slides: [DataDeletion, DeletionFeedback, Deletionemail, DeletionSuccess],
      closeUrl,
      domid: 'data_deletion_modal',
    },
  },

  '/data/deletion/2fareturn': {
    view: lazy(() =>
      import('../modals/dataPrivacy/data-deletion/introduction'),
    ),
    props: {
      redirect: 'authweb',
      slides: [DataDeletion, DeletionFeedback, Deletionemail, DeletionSuccess],
      position: 2,
      closeUrl,
      domid: 'authweb_deletion_modal',
    },
  },

  '/cookiePrefs': {
    view: lazy(() => import('./home/cookiePrefs')),
    props: {
      showBackButton: false,
      closeUrl,
    },
  },
  '/searchPrivacy': {
    view: lazy(() =>
      import('../modals/dataPrivacy/data-search/privacy-search'),
    ),
    props: {
      showBackButton,
      backUrl,
      closeUrl,
    },
  },
  '/personalization/paypal': {
    view: lazy(() => import('../modals/personalization/paypal')),
    props: {
      showBackButton,
      backUrl,
      closeUrl,
    },
  },

  '/personalization/other': {
    view: lazy(() => import('../modals/personalization/other')),
    props: {
      showBackButton,
      backUrl,
      closeUrl,
    },
  },

  '/paypalShopping/edit': {
    view: lazy(() => import('../modals/paypalShopping/edit')),
    props: {
      showBackButton: false,
      backUrl,
      closeUrl,
    },
  },

  // Use this screen mapper to load the full page modal window
}
